import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { Link } from 'react-router'

// Actions
import { userActions } from 'redux/actionCreators'

// Components
import { FormGroup, Loader } from 'components'

// Styles
import classes from './Signup.scss'

// Helpers
import _get from 'lodash.get'
import { validateRequired, emailIsValid, hasError, allowNumberOnly, inputProps } from 'helpers/formHelpers'
import { freezeScreen, unfreezeScreen } from 'helpers/utilities'
import { animateScroll } from 'react-scroll'

const FIELD_NAMES = [
  'email', 'confirmEmail', 'password', 'confirmPassword',
  'contactPersonName', 'address', 'postalCode', 'mobile',
  'pharmacyName', 'medicalLicenseNo', 'facebookName', 'lineId'
]

const mapStateToProps = (state) => ({
  attempting: _get(state, ['user', 'signupAttempting']) || false,
  attempted: _get(state, ['user', 'signupAttempted']) || false,
  statusCode: _get(state, ['user', 'error', 'response', 'statusCode'])
})
const mapDispatchToProps = (dispatch) => ({
  attemptSignup: (payload) =>
    dispatch(userActions.attemptSignup(payload)),
  setInitial: () => dispatch({ type: 'SET_INITIAL' })
})

@connect(mapStateToProps, mapDispatchToProps)
@reduxForm({ form: 'Signup', fields: FIELD_NAMES })
class Signup extends Component {
  constructor (props) {
    super(props)
    this.state = { }
  }

  static propTypes = {
    fields: PropTypes.object.isRequired,
    attemptSignup: PropTypes.func.isRequired,
    statusCode: PropTypes.number
  };

  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  componentDidMount () {
    window.objectFitImages()
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.attempted !== nextProps.attempted) {
      if (nextProps.attempted) {
        freezeScreen()
      } else {
        unfreezeScreen()
      }
    }
  }

  componentWillUnmount () {
    this.props.setInitial()
  }

  _validateInput = () => {
    const { attempting, fields } = this.props
    let error = [
      'email', 'confirmEmail', 'password', 'confirmPassword',
      'contactPersonName', 'address', 'postalCode', 'mobile',
      'pharmacyName', 'medicalLicenseNo'
    ].reduce((error, fieldName) => ({
      ...error, ...validateRequired(fields[fieldName].value, fieldName)
    }), {})

    if (!error.emailError && !emailIsValid(fields.email.value)) {
      error = { ...error, emailError: 'รูปแบบอีเมล์ไม่ถูกต้อง' }
    }
    if (!error.confirmEmailError && !emailIsValid(fields.confirmEmail.value)) {
      error = { ...error, confirmEmailError: 'รูปแบบอีเมล์ไม่ถูกต้อง' }
    }
    if (!error.emailError && !error.confirmEmailError && fields.email.value !== fields.confirmEmail.value) {
      error = { ...error, emailError: 'อีเมล์ทั้งสองไม่ตรงกัน', confirmEmailError: 'อีเมล์ทั้งสองไม่ตรงกัน' }
    }
    if (!error.passwordError && !error.confirmPasswordError && fields.password.value !== fields.confirmPassword.value) {
      error = { ...error, passwordError: 'รหัสผ่านทั้งสองไม่ตรงกัน', confirmPasswordError: 'รหัสผ่านทั้งสองไม่ตรงกัน' }
    }

    const errorY = Object.keys(error).reduce((y, key) => {
      if (y || key.indexOf('Error') === -1 || !error[key]) return y
      return document.getElementById(key).offsetTop - 151
    }, 0)
    if (errorY) animateScroll.scrollTo(errorY)

    this.setState(error)
    return !attempting && !hasError(error)
  }

  _onSignup = () => {
    const { attemptSignup, fields } = this.props
    if (this._validateInput()) {
      attemptSignup(FIELD_NAMES.reduce((payload, fieldName) => ({
        ...payload, [fieldName]: fields[fieldName].value
      }), {}))
    }
  }

  _onOkay = () => {
    this.context.router.replace('/')
  }

  render () {
    const { attempting, attempted, statusCode } = this.props
    const {
      email, confirmEmail, password, confirmPassword,
      contactPersonName, address, postalCode, mobile,
      pharmacyName, medicalLicenseNo, facebookName, lineId
    } = this.props.fields

    return (
      <div id='signup-page' className={classes.container}>
        <div className='hero'>
          <Link to='/'>
            <img className='logo' src='/images/logo.png' alt='logo' />
          </Link>
          <div className='underline' />
        </div>
        <div className={classes.header}>
          <span>ลงทะเบียน</span>
        </div>
        <div className={classes.warning}>
          <div>เมื่อลงทะเบียนเสร็จแล้ว กรุณา Add Line ID: @ccdc</div>
          <div>ส่งภาพใบอนุญาตขายยาและใบประกอบวิชาชีพ</div>
          <div>เจ้าหน้าที่จะอนุมัติการเข้าใช้งานของท่านอย่างรวดเร็ว</div>
          <img className={classes.qrcode} width='160' height='160' src='/images/line-qrcode.png' alt='qrcode' />
        </div>
        <div className={classes.section}>
          <FormGroup id='emailError' title='Email (ใช้ Email นี้เป็น Username)' centered errorMessage={this.state.emailError}>
            <input type='text' maxLength={255} {...inputProps(email)} />
          </FormGroup>
          <FormGroup id='confirmEmailError' title='ยืนยันอีเมล์' centered errorMessage={this.state.confirmEmailError}>
            <input type='text' maxLength={255} {...inputProps(confirmEmail)} />
          </FormGroup>
          <FormGroup id='passwordError' title='รหัสผ่าน' centered errorMessage={this.state.passwordError}>
            <div id='passwordError'><input type='password' {...inputProps(password)} /></div>
          </FormGroup>
          <FormGroup id='confirmPasswordError' title='ยืนยันรหัสผ่าน' centered errorMessage={this.state.confirmPasswordError}>
            <input type='password' {...inputProps(confirmPassword)} />
          </FormGroup>
        </div>

        <div className={classes.section}>
          <FormGroup id='contactPersonNameError' title='ชื่อผู้ติดต่อหลัก' centered errorMessage={this.state.contactPersonNameError}>
            <input type='text' maxLength={63} {...inputProps(contactPersonName)}
              placeholder='' />
          </FormGroup>
          <FormGroup id='addressError' title='ที่อยู่จัดส่ง' centered errorMessage={this.state.addressError}>
            <input type='text' maxLength={255} {...inputProps(address)} />
          </FormGroup>
          <FormGroup id='postalCodeError' title='รหัสไปรษณีย์' centered errorMessage={this.state.postalCodeError}>
            <input type='text' {...allowNumberOnly(postalCode, true, 5)} />
          </FormGroup>
          <FormGroup rel='mobileError' title='เบอร์ติดต่อ' centered errorMessage={this.state.mobileError}>
            <input type='text' {...allowNumberOnly(mobile, true, 10)} />
          </FormGroup>
          <FormGroup id='pharmacyNameError' title='ชื่อร้าน/บริษัท' centered errorMessage={this.state.pharmacyNameError}>
            <input type='text' maxLength={127} {...inputProps(pharmacyName)} />
          </FormGroup>
          <FormGroup id='medicalLicenseNoError' title='เลขที่ใบอนุญาตขายยาหรือประกอบโรคศิลป์ (กรอกแค่เลขเดียว)' centered errorMessage={this.state.medicalLicenseNoError}>
            <input type='text' maxLength={31} {...inputProps(medicalLicenseNo)} />
          </FormGroup>
        </div>

        <div className={classes.section}>
          <FormGroup id='facebookNameError' title='ชื่อที่ใช้ใน Facebook' centered errorMessage={this.state.facebookNameError}>
            <input type='text' maxLength={31} {...inputProps(facebookName)} />
          </FormGroup>
          <FormGroup id='lineIdError' title='ID Line' centered errorMessage={this.state.lineIdError}>
            <input type='text' maxLength={31} {...inputProps(lineId)} />
          </FormGroup>
        </div>

        <div className='btn btn-round' onClick={this._onSignup}>
          {attempting ? <Loader /> : <span>ลงทะเบียน</span>}
        </div>
        {statusCode === 409 && (
          <div className={classes.warning}>
            <span>*อีเมล์​ {this.props.fields.email.value} ถูกใช้งานแล้ว</span>
          </div>
        )}
        {statusCode && statusCode !== 409 && (
          <div className={classes.warning}>
            <span>*เกิดข้อผิดพลาดในการลงทะเบียน กรุณาลองใหม่อีกครั้ง หรือติดต่อ Line ID: @ccdc</span>
          </div>
        )}
        {attempted && (
          <div className='overlay'>
            <div className='overlay-cell'>
              <div className='lightbox' style={{ height: 480 }}>
                <div className='line1'>
                  <span>ท่านได้ลงทะเบียนเสร็จสมบูรณ์แล้ว</span>
                </div>
                <div className='line2'>
                  <div>
                    <div className='red'>กรุณา Add Line ID : @ccdc</div>
                    <img className={classes.qrcode} width='120' height='120' src='/images/line-qrcode.png' alt='qrcode' />
                  </div>
                  <div>และส่งเอกสารเพิ่มเติมตามรายละเอียดข้างล่าง</div>
                  <div>เจ้าหน้าที่จะดำเนินการอนุมัติการใช้งานของท่านอย่างรวดเร็วค่ะ</div>
                </div>
                <div className='line3'>
                  <div>
                    <img style={{ marginRight: 5 }} width='12' height='10' src='/images/icon-heart.png' alt='heart' />
                    <span>ร้านยา/คลินิก/โรงพยาบาล: 1.ภาพใบอนุญาตขายยา/คลินิก/สถานพยาบาล  2.ใบประกอบโรคศิลป์</span>
                  </div>
                  <div>
                    <img style={{ marginRight: 5 }} width='12' height='10' src='/images/icon-heart.png' alt='heart' />
                    <span>ร้านค้าทั่วไป: ภาพป้ายหน้าร้าน หรือ ใบทะเบียนพาณิชย์</span>
                  </div>
                  <div style={{ marginTop: 10 }}>พบปัญหาการใช้งานหรือต้องการสอบถามข้อมูลเพิ่มเติมติดต่อ 063-464-6194, 063-464-6195, 063-464-6196</div>
                  <div>วันจันทร์ - วันเสาร์​เวลา 9.00 - 18.00 น. หรือ Email chatchaipharmacy@gmail.com</div>
                </div>
                <img className='mascot' src='/images/mascot.png' alt='mascot' />
                <div className='btn-close' onClick={this._onOkay}>X</div>
                <div className='btn-ok' onClick={this._onOkay}>
                  <span>ตกลง</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default Signup



// WEBPACK FOOTER //
// ./src/containers/Signup.js